import React, { useEffect, useState } from "react";
import { useLocation } from '@reach/router';
import Sticky from "react-stickynode";
import { DrawerProvider } from "common/contexts/DrawerContext";
import ContactDetails from "../ContactDetails";
import Navbar from "containers/Home/Navbar";
import Footer from "containers/Home/Footer";
import { GlobalStyle, InteriorWrapper, ContentWrapper } from "containers/Home/global.style";
import { ResetCSS } from "common/assets/css/style";

export default function Layout({ children }) { 
  const location = useLocation();

  const excludedPaths = ["/appointment.php/","/appointment.php", "/Patch-solution/","/Patch-solution", "/wig-solution/","/wig-solution", "/Hair-patch-cost/","/Hair-patch-cost", "/hair-Patch-solution/","/hair-Patch-solution", "/Hair-patch-for-men/","/Hair-patch-for-men", "/hair-wig-solution/","/hair-wig-solution", "/Hair-wig-cost-price/","/Hair-wig-cost-price","/Hair-wig-for-women/","/Hair-wig-for-women","/Hair-wig-for-men/","/Hair-wig-for-men"];

  return ( 
    <div className="layout-radiance">
      <ResetCSS />
      <GlobalStyle />
      <InteriorWrapper>
        <Sticky top={0} innerZ={9999} activeClass="sticky-nav-active">
          <DrawerProvider>
            <Navbar />
          </DrawerProvider>
        </Sticky>

        <ContentWrapper>
          {children}
        </ContentWrapper>

        {!excludedPaths.includes(location.pathname) && <ContactDetails />}

        <Footer />
      </InteriorWrapper>
    </div> 
  ); 
}
